export const categories = [
  { id: 1, slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '浪漫甜蜜的恋爱韩漫故事', count: 128 },
  { id: 2, slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '魔法与奇幻世界的冒险之旅', count: 96 },
  { id: 3, slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', description: '热血刺激的动作打斗漫画', count: 87 },
  { id: 4, slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理故事', count: 64 },
  { id: 5, slug: 'xiaoyuan', name: '校园', icon: 'ri-building-line', description: '青春洋溢的校园生活漫画', count: 73 },
  { id: 6, slug: 'chuanyue', name: '穿越', icon: 'ri-time-line', description: '穿越时空的奇妙旅程', count: 55 },
  { id: 7, slug: 'danmei', name: '耽美', icon: 'ri-star-line', description: '唯美动人的耽美韩漫', count: 42 },
  { id: 8, slug: 'jingji', name: '竞技', icon: 'ri-trophy-line', description: '紧张激烈的竞技对战漫画', count: 38 },
];